import type { Nullable } from 'common/types'
import { useLayoutEffect, useMemo } from 'react'

export const useResizeObserver = (
  container: Nullable<HTMLElement>,
  callback: ResizeObserverCallback,
) => {
  const resizeObserver = useMemo(() => new ResizeObserver(callback), [callback])

  useLayoutEffect(() => {
    if (!container) return

    resizeObserver.observe(container)

    return () => {
      resizeObserver.unobserve(container)
    }
  }, [container, resizeObserver])
}
